module.exports = __webpack_public_path__ + "static/img/bg_xiazai_bang_1.cd1b977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_xiazai_bang_1.png
// module id = 9y7S
// module chunks = 0